export default __webpack_public_path__ + "static/media/mobilitybanner.7887f158.webp";